import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"
import Fab from "@material-ui/core/Fab"

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    "&.MuiFab-extended .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
    },
  },
  transparent: {
    background: "transparent",
    boxShadow: "none",
    color: theme.palette.secondary.main,
    "&:hover": {
      color: theme.palette.secondary.contrastText,
    },
  },
}))

export default function Action({ children, color, ...props }) {
  const classes = useStyles()

  return (
    <Fab
      className={clsx(classes.root, {
        [classes.transparent]: color === "transparent",
      })}
      color={color || "secondary"}
      // size="medium"
      {...props}
    >
      {children}
    </Fab>
  )
}
